import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../../../../components/buttons/buttons.component'
import {
	TextInput,
	SelectInput
} from '../../../../../components/form-components/inputs.component'
import { routes } from '../../../../../constants/routes.constants'

const StyledGridContainer = styled.div`
	display: grid;
	grid-gap: 15px;
	grid-template: auto / auto minmax(120px, 20%);
`

const StyledButtonContainer = styled.div`
	padding-top: 2.7rem;
	display: grid;
	grid-gap: 15px;
	grid-template-columns: repeat(2, auto);
	justify-content: end;
`

class SearchForm extends Component {
	initialValues = {
		name: '',
		status: 'true'
	}

	constructor(props) {
		super(props)
		this.periodRef = React.createRef()
		this.initialDateRef = React.createRef()
		this.finalDateRef = React.createRef()
	}

	componentDidMount() {
		const { onSubmit } = this.props
		setTimeout(() => {
			onSubmit(this.refs.form.state.values)
		}, 0)
	}

	render() {
		const { onSubmit, history } = this.props
		return (
			<div>
				<Formik
					ref={'form'}
					initialValues={this.initialValues}
					onSubmit={onSubmit}
					render={props => (
						<Form className="form" noValidate>
							<StyledGridContainer>
								<TextInput
									id="name"
									label="Nome"
									autoFocus={true}
									{...props}
								/>
								<SelectInput
									id="status"
									label="Situação"
									defaultValue={statusOptions[1]}
									options={statusOptions}
									multi={false}
									{...props}
								/>
							</StyledGridContainer>
							<StyledButtonContainer>
								<Button
									secondary
									type="button"
									onClick={e => {
										e.preventDefault()
										history.push(`${routes.ADMIN}/funcionario`)
									}}
									data-permission="35974DCAC3C7A2AA91CF165F2B05AE7C206487FD">
									Novo
								</Button>
								<Button
									data-permission="CB0FB1A9065FAE57A333F7C0597D74EB162060D4"
									primary
									type="submit">
									Consultar
								</Button>
							</StyledButtonContainer>
						</Form>
					)}
				/>
			</div>
		)
	}
}

const statusOptions = [
	{ value: 'none', label: 'Todos' },
	{ value: 'true', label: 'Ativos' },
	{ value: 'false', label: 'Inativos' }
]

export default SearchForm
